import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54819072"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "no-results"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ingen resultat", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "order-list-info" }
const _hoisted_6 = { class: "order-list-info__numbers" }
const _hoisted_7 = { class: "order-list-pagination order-list-info__pagination" }
const _hoisted_8 = {
  key: 0,
  class: "order-list-info__buttons"
}
const _hoisted_9 = { class: "order-table-wrapper" }
const _hoisted_10 = { class: "mobile-list" }
const _hoisted_11 = {
  key: 0,
  class: "name"
}
const _hoisted_12 = {
  key: 1,
  class: "result"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Ordrenummer", -1))
const _hoisted_14 = { class: "result" }
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  key: 2,
  class: "name"
}
const _hoisted_17 = { class: "result" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Kunde", -1))
const _hoisted_19 = { class: "result" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Ordredato", -1))
const _hoisted_21 = { class: "result" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name span-2" }, "Kommentar", -1))
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = {
  key: 3,
  class: "name span-2"
}
const _hoisted_25 = {
  key: 4,
  class: "result"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-lg" }, "Låse opp", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-lg" }, "Lås", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Handling", -1))
const _hoisted_29 = { class: "result" }
const _hoisted_30 = {
  key: 5,
  class: "name"
}
const _hoisted_31 = {
  key: 6,
  class: "result"
}
const _hoisted_32 = { class: "order-table" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "mobile-none" }, "Ordrenr", -1))
const _hoisted_35 = {
  key: 1,
  class: "mobile-none"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Kunde", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Ordredato", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Kommentar", -1))
const _hoisted_39 = { key: 2 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Handling", -1))
const _hoisted_41 = { key: 3 }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { class: "order-number-td" }
const _hoisted_44 = {
  key: 1,
  class: "mobile-none"
}
const _hoisted_45 = { class: "order-customer-td" }
const _hoisted_46 = { class: "mobile-none" }
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = {
  key: 2,
  class: "order-locked"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-lg" }, "Låse opp", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-lg" }, "Lås", -1))
const _hoisted_51 = { key: 3 }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { class: "order-list-pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_Link = _resolveComponent("Link")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.orders?.total === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : (_ctx.orders)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, " Viser " + _toDisplayString(_ctx.orders.data.length) + " av totalt " + _toDisplayString(_ctx.orders.total) + " ordre ", 1),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Pagination, {
                  size: _ctx.paginationSize,
                  paginate: _ctx.orders,
                  preserveScroll: ""
                }, null, 8, ["size", "paginate"])
              ]),
              (_ctx.orders.total > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders?.data, (order) => {
                    return (_openBlock(), _createElementBlock("li", null, [
                      (_ctx.type === 'weborder')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Fakturanr."))
                        : _createCommentVNode("", true),
                      (_ctx.type === 'weborder')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(order.invoice?.id), 1))
                        : _createCommentVNode("", true),
                      _hoisted_13,
                      _createElementVNode("p", _hoisted_14, [
                        _createElementVNode("a", {
                          class: "order-link",
                          href: _ctx.route('orders.show', { order: order.id }),
                          target: "_blank"
                        }, _toDisplayString(order.id), 9, _hoisted_15)
                      ]),
                      (_ctx.type === 'weborders')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_16, "WC Ordrenummer"))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", _hoisted_17, [
                        _createVNode(_component_Link, {
                          class: "order-link",
                          href: _ctx.route('orders.show', { order: order.id })
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(order.wc_order_id), 1)
                          ]),
                          _: 2
                        }, 1032, ["href"])
                      ]),
                      _hoisted_18,
                      _createElementVNode("p", _hoisted_19, _toDisplayString(order.client_model?.firstname) + " " + _toDisplayString(order.client_model?.lastname), 1),
                      _hoisted_20,
                      _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.dayjs(order.date).format("L LT")), 1),
                      _hoisted_22,
                      _createElementVNode("p", {
                        class: "result span-2",
                        innerHTML: _ctx.addLineBreaks(order.comment_order ?? '')
                      }, null, 8, _hoisted_23),
                      (_ctx.type === 'orders'  && _ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_24, "låst"))
                        : _createCommentVNode("", true),
                      (_ctx.type === 'orders'  && _ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_25, [
                            (order.locked)
                              ? (_openBlock(), _createBlock(_component_Button, {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.unlockOrder(order.id)),
                                  color: "red",
                                  class: "lock-btn"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_26,
                                    _createVNode(_component_SvgIcon, {
                                      class: "",
                                      width: "1.2rem",
                                      height: "1.2rem",
                                      type: "mdi",
                                      path: _ctx.mdiLock
                                    }, null, 8, ["path"])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : (_openBlock(), _createBlock(_component_Button, {
                                  key: 1,
                                  onClick: ($event: any) => (_ctx.lockOrder(order.id)),
                                  color: "green",
                                  class: "lock-btn"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_27,
                                    _createVNode(_component_SvgIcon, {
                                      class: "text-green",
                                      width: "1.2rem",
                                      height: "1.2rem",
                                      type: "mdi",
                                      path: _ctx.mdiLockOpenVariant
                                    }, null, 8, ["path"])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_28,
                      _createElementVNode("p", _hoisted_29, [
                        _createVNode(_component_Link, {
                          href: _ctx.route('orders.show', { order: order.id })
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Button, { color: "info" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Se på ordre")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["href"])
                      ]),
                      (_ctx.type === 'orders')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_30, "Ordretotal"))
                        : _createCommentVNode("", true),
                      (_ctx.type === 'orders')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(order.total_inc_mva) + " ink mva ", 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 256))
                ])
              ]),
              _createVNode(_component_Card, null, {
                default: _withCtx(() => [
                  _createElementVNode("table", _hoisted_32, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        (_ctx.type === 'weborder')
                          ? (_openBlock(), _createElementBlock("th", _hoisted_33, "Fakturanr"))
                          : _createCommentVNode("", true),
                        _hoisted_34,
                        (_ctx.type === 'weborders')
                          ? (_openBlock(), _createElementBlock("th", _hoisted_35, " WC Ordrenr "))
                          : _createCommentVNode("", true),
                        _hoisted_36,
                        _hoisted_37,
                        _hoisted_38,
                        (_ctx.type === 'orders'  && _ctx.isAdmin)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_39, "Låst"))
                          : _createCommentVNode("", true),
                        _hoisted_40,
                        (_ctx.type === 'orders')
                          ? (_openBlock(), _createElementBlock("th", _hoisted_41, "Ordretotal"))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders.data, (order) => {
                        return (_openBlock(), _createElementBlock("tr", null, [
                          (_ctx.type === 'weborder')
                            ? (_openBlock(), _createElementBlock("td", _hoisted_42, _toDisplayString(order.invoice?.id), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", _hoisted_43, [
                            _createVNode(_component_Link, {
                              class: "order-link",
                              href: _ctx.route('orders.show', { order: order.id })
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(order.id), 1)
                              ]),
                              _: 2
                            }, 1032, ["href"])
                          ]),
                          (_ctx.type === 'weborders')
                            ? (_openBlock(), _createElementBlock("td", _hoisted_44, _toDisplayString(order.wc_order_id), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", _hoisted_45, _toDisplayString(order.client_model?.firstname) + " " + _toDisplayString(order.client_model?.lastname), 1),
                          _createElementVNode("td", _hoisted_46, _toDisplayString(_ctx.dayjs(order.date).format("L LT")), 1),
                          _createElementVNode("td", {
                            class: "order-comment",
                            innerHTML: _ctx.addLineBreaks(order.comment_order ?? '')
                          }, null, 8, _hoisted_47),
                          (_ctx.type === 'orders' && _ctx.isAdmin)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_48, [
                                (order.locked)
                                  ? (_openBlock(), _createBlock(_component_Button, {
                                      key: 0,
                                      onClick: ($event: any) => (_ctx.unlockOrder(order.id)),
                                      color: "red",
                                      class: "lock-btn"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_49,
                                        _createVNode(_component_SvgIcon, {
                                          class: "",
                                          width: "1.2rem",
                                          height: "1.2rem",
                                          type: "mdi",
                                          path: _ctx.mdiLock
                                        }, null, 8, ["path"])
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : (_openBlock(), _createBlock(_component_Button, {
                                      key: 1,
                                      onClick: ($event: any) => (_ctx.lockOrder(order.id)),
                                      color: "green",
                                      class: "lock-btn"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_50,
                                        _createVNode(_component_SvgIcon, {
                                          class: "text-green",
                                          width: "1.2rem",
                                          height: "1.2rem",
                                          type: "mdi",
                                          path: _ctx.mdiLockOpenVariant
                                        }, null, 8, ["path"])
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", null, [
                            _createVNode(_component_Link, {
                              href: _ctx.route('orders.show', { order: order.id })
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Button, { color: "info" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Se på ordre")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["href"])
                          ]),
                          (_ctx.type === 'orders')
                            ? (_openBlock(), _createElementBlock("td", _hoisted_51, [
                                (order.total_inc_mva != undefined)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_52, _toDisplayString(parseFloat(order.total_inc_mva).toLocaleString("nb", {
                        currency: "NOK",
                        style: "currency",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      })) + " ink mva ", 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 256))
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createVNode(_component_Pagination, {
                size: _ctx.paginationSize,
                paginate: _ctx.orders
              }, null, 8, ["size", "paginate"])
            ])
          ]))
        : _createCommentVNode("", true)
  ]))
}